import React, { Component, useEffect, useState } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import SimpleReactValidator from "simple-react-validator";
import Switch from "react-switch";
import SearchInput from "react-search-input";
import ReactDragListView from "react-drag-listview";
import LoadingButton from "../common/LoadingButton";

class CreateProgramComms extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      name: this.props.resp ? this.props.resp.data.output.name : "",
      eFrom: this.props.resp ? (this.props.resp.data.output.efrom || this.props.resp.data.output.eFrom || "") : "",
      eSubject: this.props.resp ? (this.props.resp.data.output.esubject || this.props.resp.data.output.eSubject || "") : "",
      eTo: this.props.resp ? (this.props.resp.data.output.eto || this.props.resp.data.output.eTo || "") : "",
      eCC: this.props.resp ? (this.props.resp.data.output.ecc || this.props.resp.data.output.eCC || "") : "",
      eBCC: this.props.resp ? (this.props.resp.data.output.ebcc || this.props.resp.data.output.eBCC || "") : "",
      eTemplate: this.props.resp ? (this.props.resp.data.output.etemplate || this.props.resp.data.output.eTemplate || "") : "",
      sTemplate: this.props.resp ? this.props.resp.data.output.stemplate : "",
      stemplateId: this.props.resp ? this.props.resp.data.output.stemplateId : "",
      nTemplate: this.props.resp ? this.props.resp.data.output.ntemplate : "",
      wTemplate: this.props.resp ? this.props.resp.data.output.wtemplate : "",
      eActive: this.props.resp ? this.props.resp.data.output.eactive : false,
      sActive: this.props.resp ? this.props.resp.data.output.sactive : false,
      nActive: this.props.resp ? this.props.resp.data.output.nactive : false,
      wActive: this.props.resp ? this.props.resp.data.output.wactive : false,
      contentId: this.props.resp ? this.props.resp.data.output.contentId : "",
      submitting: false,
    };

    this.emailActiveHandleChange = this.emailActiveHandleChange.bind(this);
    this.smsActiveHandleChange = this.smsActiveHandleChange.bind(this);
    this.waActiveHandleChange = this.waActiveHandleChange.bind(this);
    this.notifyActiveHandleChange = this.notifyActiveHandleChange.bind(this);
  }

  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount()
    );
  };

  nameHandleChange = (event) => {
    this.setState({ name: event.target.value });
  };

  // ✅ ONLY FIX IN ENTIRE FILE
  emailBccHandleChange = (event) => {
    this.setState({ eBCC: event.target.value });
  };

  emailCcHandleChange = (event) => {
    this.setState({ emailCc: event.target.value });
  };

  emailBodyHandleChange = (event) => {
    this.setState({ emailBody: event.target.value });
  };

  emailActiveHandleChange = (checked) => {
    this.setState({ eActive: checked });
  };

  smsBodyHandleChange = (event) => {
    this.setState({ smsBody: event.target.value });
  };

  smsActiveHandleChange = (checked) => {
    this.setState({ sActive: checked });
  };

  waActiveHandleChange = (checked) => {
    this.setState({ wActive: checked });
  };

  waBodyHandleChange = (event) => {
    this.setState({ waBody: event.target.value });
  };

  notifyActiveHandleChange = (checked) => {
    this.setState({ nActive: checked });
  };

  notifyBodyHandleChange = (event) => {
    this.setState({ notifyBody: event.target.value });
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ submitting: true });
      const token = localStorage.getItem("token");
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parts.pop();
      programid = parseInt(programid);
      const pathSegments = window.location.pathname.split("/");
      let compid = pathSegments[pathSegments.length - 2];

      if (this.props.resp) {
        axios.patch(
          Constants.api + "program/comms/" + this.props.resp.data.output.id,
          {
            name: this.state.name,
            eFrom: this.state.eFrom,
            eSubject: this.state.eSubject,
            eTo: this.state.eTo,
            eCC: this.state.eCC,
            eBCC: this.state.eBCC,
            eTemplate: this.state.eTemplate,
            stemplateId: this.state.stemplateId,
            sTemplate: this.state.sTemplate,
            nTemplate: this.state.nTemplate,
            wTemplate: this.state.wTemplate,
            eActive: this.state.eActive,
            sActive: this.state.sActive,
            nActive: this.state.nActive,
            wActive: this.state.wActive,
            contentId: this.state.contentId
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              company: compid,
              program: programid,
              appVersion: Constants.av,
              platform: Constants.pt
            }
          }
        )
          .then((res) => {
            if (res.status == 200) {
              swal("Template Updated");
              this.onCancelTrigger(0);
            }
          })
          .finally(() => {
            this.setState({ submitting: false });
          });
      } else {
        axios.post(
          Constants.api + "program/comms",
          {
            name: this.state.name,
            eFrom: this.state.eFrom,
            eSubject: this.state.eSubject,
            eTo: this.state.eTo,
            eCC: this.state.eCC,
            eBCC: this.state.eBCC,
            eTemplate: this.state.eTemplate,
            sTemplate: this.state.sTemplate,
            stemplateId: this.state.stemplateId,
            nTemplate: this.state.nTemplate,
            wTemplate: this.state.wTemplate,
            eActive: this.state.eActive,
            sActive: this.state.sActive,
            isnActive: this.state.isnActive,
            wActive: this.state.wActive,
            contentId: this.state.contentId
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              company: compid,
              program: programid,
              appVersion: Constants.av,
              platform: Constants.pt
            }
          }
        )
          .then((res) => {
            if (res.status == 201) {
              swal("Template Added");
              this.onCancelTrigger(0);
            }
          })
          .finally(() => {
            this.setState({ submitting: false });
          });
      }
    } else {
      this.setState({ submitting: false });
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  onCancelTrigger = (event) => {
    this.props.setViewMode(event);
    event.preventDefault();
  };

  render() {
    return (
      <>
        <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
          <div class="card mt-4">
            <div class="card-header">
              <h5>Program Communication</h5>
            </div>

            <form onSubmit={this.handleFormSubmit}>
              <div class="card-body pt-0">

                {/* NAME */}
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-label mt-4">Name</label>
                    <input class="form-control" name="name" value={this.state.name} onChange={this.nameHandleChange} />
                  </div>
                </div>

                {/* EMAIL */}
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label mt-4">Email Active</label>
                    <Switch onChange={this.emailActiveHandleChange} checked={this.state.eActive} />
                  </div>
                </div>

                {this.state.eActive ?
                  <>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label mt-4">Email To</label>
                        <input class="form-control" name="eTo" value={this.state.eTo} placeholder="e.g. orders@example.com (overrides CNF recipient)" onChange={this.handleInputChange} />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label mt-4">Email From</label>
                        <input class="form-control" name="eFrom" value={this.state.eFrom} onChange={this.handleInputChange} />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <label class="form-label mt-4">Email Subject</label>
                        <input class="form-control" name="eSubject" value={this.state.eSubject} onChange={this.handleInputChange} />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label mt-4">Email CC</label>
                        <input class="form-control" name="eCC" value={this.state.eCC} onChange={this.handleInputChange} />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label mt-4">Email BCC</label>
                        <input class="form-control" name="eBCC" value={this.state.eBCC} onChange={this.emailBccHandleChange} />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <label class="form-label mt-4">Email Body</label>
                        <textarea class="form-control" name="eTemplate" onChange={this.handleInputChange}>
                          {this.state.eTemplate}
                        </textarea>
                      </div>
                    </div>
                  </> : ""
                }

                {/* SMS */}
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label mt-4">SMS Active</label>
                    <Switch onChange={this.smsActiveHandleChange} checked={this.state.sActive} />
                  </div>
                </div>

                {this.state.sActive ?
                  <>
                    <textarea class="form-control" name="sTemplate" onChange={this.handleInputChange}>
                      {this.state.sTemplate}
                    </textarea>
                    <input class="form-control" name="stemplateId" value={this.state.stemplateId} onChange={this.handleInputChange} />
                  </> : ""
                }

                {/* WHATSAPP */}
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label mt-4">Whatsapp Active</label>
                    <Switch onChange={this.waActiveHandleChange} checked={this.state.wActive} />
                  </div>
                </div>

                {this.state.wActive ?
                  <textarea class="form-control" name="wTemplate" onChange={this.handleInputChange}>
                    {this.state.wTemplate}
                  </textarea> : ""
                }

                {/* NOTIFICATION */}
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label mt-4">Notification Active</label>
                    <Switch onChange={this.notifyActiveHandleChange} checked={this.state.isnActive} />
                  </div>
                </div>

                {this.state.isnActive ?
                  <textarea class="form-control" name="nTemplate" onChange={this.handleInputChange}>
                    {this.state.nTemplate}
                  </textarea> : ""
                }

                {/* SAVE */}
                <div class="mt-4 text-end">
                  <LoadingButton class="btn bg-gradient-success" type="submit" loading={this.state.submitting}>Save</LoadingButton>
                </div>

              </div>
            </form>
          </div>
        </main>
      </>
    );
  }
}

export default CreateProgramComms;
